export default "__VITE_ASSET__DdtIKLCD__"